module.exports = __webpack_public_path__ + "static/media/u-story-group-icon.d28e489b.png";